/* Optional per-instance spacing, also covers AJAX cards and relocated drawers. */
(() => {
  if (window.iuropSpacing) return;
  const configs = new Map();
  let frame = 0;
  let observer;
  const attribute = 'data-iurop-spacing';
  function mark(element, token, active) {
    if (!element) return;
    const tokens = new Set((element.getAttribute(attribute) || '').split(/\s+/).filter(Boolean));
    if (active) tokens.add(token); else tokens.delete(token);
    if (tokens.size) element.setAttribute(attribute, [...tokens].join(' '));
    else element.removeAttribute(attribute);
  }
  function apply() {
    frame = 0;
    const current = new Set();
    document.querySelectorAll('script[data-iurop-spacing-instance]').forEach(script => {
      let config;
      try { config = JSON.parse(script.textContent); } catch (_) { return; }
      if (!config.token || !config.selector || !Number.isInteger(config.index) || config.index < 1) return;
      current.add(config.token);
      let matches;
      try { matches = document.querySelectorAll(config.selector); } catch (_) { return; }
      const element = matches[config.index - 1];
      const previous = configs.get(config.token);
      if (previous !== element) {
        mark(previous, config.token, false);
        mark(element, config.token, true);
      }
      configs.set(config.token, element);
    });
    configs.forEach((element, token) => {
      if (!current.has(token)) { mark(element, token, false); configs.delete(token); }
    });
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(apply);
  }
  function refresh() {
    if (document.querySelector('script[data-iurop-spacing-instance]')) {
      if (!observer) {
        observer = new MutationObserver(schedule);
        observer.observe(document.body, { childList: true, subtree: true });
      }
    } else if (observer) { observer.disconnect(); observer = undefined; }
    schedule();
  }
  window.iuropSpacing = { refresh };
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
